import React from 'react';
import EditorDelete from '@wix/da-ds/pkg/Icons/24x24/EditorDelete';
import cn from 'classnames';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
import { useTranslation } from 'react-i18next';
import s from '../../../../components/menus/buttons/buttons.scss';
const Delete = ({ editor })=>{
    const { t } = useTranslation('editor');
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:deviation:delete",
        icon: EditorDelete,
        onClick: ()=>editor.chain().focus().daDeviationThumbDelete().run(),
        className: cn(s['button']),
        tooltipHoverDelay: 2000,
        tooltipText: t('ext.deviation.toolbar.delete'),
        "aria-label": t('ext.deviation.toolbar.delete')
    });
};
Delete.displayName = 'Delete';
export default Delete;

//# sourceMappingURL=Delete.js.map